import BaseModifierBehavior from './BaseModifierBehavior';

export default class PickaxeModifierBehavior extends BaseModifierBehavior {}
